module.exports = __webpack_public_path__ + "img/bank.0dacd002.svg";